import { FC } from "react";
import { Outlet } from "react-router-dom";
import { CheckoutProvider } from "../../providers/Checkout/CheckoutProvider";
import { PlansProvider } from "../../providers/Financial/Plans/PlansProvider";

interface Props {
  element?: any;
  path?: string;
}

export const PricingRoute: FC<Props> = () => {
  return (
    <CheckoutProvider>
      <PlansProvider>
        <Outlet />
      </PlansProvider>
    </CheckoutProvider>
  );
};
